module.exports = __webpack_public_path__ + "img/banner-b1@1x.a04cf78a.jpg";